import { render, staticRenderFns } from "./Regions.vue?vue&type=template&id=4bf36ce4"
import script from "./Regions.js?vue&type=script&lang=js&external"
export * from "./Regions.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports